// storybook-ignore: tunn infrastruktur-wrapper runt NewtonLoaderCSS (som har egen story). Avsiktligt utan story, räkna den inte som saknad.
import * as React from 'react';

import './style.scss';

import {NewtonLoaderCSS} from 'components/atoms/Loaders/NewtonLoaderCSS';


export const TemplateLoader: React.FunctionComponent = ({}) => {
    return (
        <div className="template-loader">
            <NewtonLoaderCSS />
        </div>
    )
};
